import * as cx from 'classnames';
import { jQuery as $ } from 'mk/jQuery';
import * as msgs from 'mk/msgs';
import { login_url } from 'mk/urls/functions';
import * as React from 'react';

declare const Like: any;

interface OwnProps {
    isLikeable: boolean;
    isLikedByMe: boolean;
    postUrl: string;

    onChange(data: {
        count: number;
        isLikedByMe: boolean;
    });
}

interface State {
    loading: boolean;
}

/**
 * TODO: Resolve FAKE context
 * TODO: Use one XHR library - currently this is using jQuery because mk/xhr needs context.apiAuth (because first TODO)
 */
export class LikeControl extends React.Component<OwnProps, State> {

    constructor(props, context) {
        super(props, context);

        this.state = {
            loading: false,
        };
    }

    public render() {
        if (!this.props.isLikeable) {
            return null;
        }

        // TODO: Load this from some context and make it reusable
        const isAuth = (window as any).MK.requestUser.username !== 'anonymous';

        const texts = Like.getTexts();

        const text = this.props.isLikedByMe ? texts.remove : texts.add;

        if (isAuth) {
            return (
                <a
                    href="#"
                    className={cx('like-control', { 'state-0': !this.props.isLikedByMe, 'state-1': this.props.isLikedByMe })}
                    onClick={this.toggleLike}
                >
                    <span className="state-msg">{text}</span>
                </a>
            );
        } else {
            // TODO: Move location.pathname to props?
            return (
                <a href={login_url({ next: location.pathname })} className="like-control state-0">
                    <span className="state-msg">{text}</span>
                </a>
            );
        }
    }

    private toggleLike = (e) => {
        // Links will not scroll
        e.preventDefault();

        // Prevent double submit
        if (this.state.loading) {
            return;
        }

        this.setState({ loading: true });

        const texts = Like.getTexts();
        const state = !this.props.isLikedByMe;

        $.post(this.props.postUrl, { state }, (data) => {
            msgs.alert(state ? texts.added : texts.removed);
            if (this.props.onChange) {
                this.props.onChange({
                    count: data.count,
                    isLikedByMe: state,
                });
            }

            this.setState({ loading: false });
        }).fail((XMLHttpRequest, textStatus, errorThrown) => {
            window.alert('The item could not be liked, try later. Error:' + textStatus + ' ' + errorThrown);
        });
    };
}
